export const setActiveShipment = (dispatch, shipmentId) => {
    dispatch({type: 'SET_ACTIVE_SHIPMENT', payload: shipmentId})
}
